import { DatePicker, Input, Select } from "antd";
import React, { useState } from "react";
import SelectControl from "./SelectControl";
import { STATE_AND_CITIES } from "../../../utils/StateAndCities";
import moment from "moment";
const { RangePicker } = DatePicker;

const KEYS = Object.keys(STATE_AND_CITIES);
const states = KEYS?.sort((a, b) =>
  a.localeCompare(b, undefined, { sensitivity: "base" }),
);
const cities = [
  ...new Set(
    KEYS?.flatMap(
      (key) => STATE_AND_CITIES[key]?.map((item) => item?.city) || [],
    ),
  ),
]?.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

const ParameterValue = ({
  group,
  con,
  setConditions,
  sources,
  qualifications,
  isHasErrorValue,
  locations,
  interviewStatus,
  positions,
  modeOfInterviews,
  languages,
  callStatus,
  noticePeriods,
  departments,
  industries
}) => {
  const type = con?.label;
  const value = con?.value;

  const onChangeHandler = (groupId, conId, value) => {
    setConditions((prev) =>
      prev.map((group) => {
        if (group._id === groupId) {
          return {
            ...group,
            conditions: group.conditions.map((con) =>
              con._id === conId ? { ...con, value } : con,
            ),
          };
        }
        return group;
      }),
    );
  };

  const handleDate = (value, dateString, groupId, conId) => {
    if (value === null) {
      onChangeHandler(groupId, conId, [
        moment().format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ]);
    } else {
      let startDate = moment(dateString[0]).format("YYYY-MM-DD");
      let endDate = moment(dateString[1]).format("YYYY-MM-DD");
      onChangeHandler(groupId, conId, [startDate, endDate]);
    }
  };

  function disableFutureDates(current) {
    const tomorrowEnd = moment().endOf("day");
    return current && current > tomorrowEnd;
  }

  switch (type) {
    case "dateApplied":
      return (
        <RangePicker
          format="YYYY-MM-DD"
          onChange={(value, dateString) =>
            handleDate(value, dateString, group?._id, con?._id)
          }
          className="w-full"
          value={[
            value?.[0] ? moment(value[0]) : null,
            value?.[1] ? moment(value[1]) : null,
          ]}
          disabledDate={disableFutureDates}
        />
      );

    case "dob":
    case "totalExperience":
    case "currentCtc":
      return (
        <Input
          status={isHasErrorValue}
          type="text"
          onChange={(e) =>
            onChangeHandler(group?._id, con?._id, e.target.value)
          }
          value={value}
          placeholder="e.g. 18"
        />
      );
    case "language":
      return (
        <SelectControl
          mode="multiple"
          status={isHasErrorValue}
          options={languages || []}
          placeholder="e.g. English"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
    case "qualification":
      return (
        <SelectControl
          mode="multiple"
          status={isHasErrorValue}
          options={qualifications || []}
          placeholder="e.g. Graduate"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
    case "source":
      return (
        <SelectControl
          mode="multiple"
          status={isHasErrorValue}
          options={sources}
          placeholder="e.g. Whatsapp"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
    case "jobRole":
      return (
        <SelectControl
          mode="multiple"
          status={isHasErrorValue}
          options={positions || []}
          placeholder="e.g. Full Time"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
    case "preferredLocation":
      return (
        <SelectControl
          mode="multiple"
          status={isHasErrorValue}
          options={locations ? [...locations, ""] : [""]}
          placeholder="e.g. Amritsar"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
    case "modeOfInterview":
      return (
        <SelectControl
          mode="multiple"
          status={isHasErrorValue}
          options={modeOfInterviews || []}
          placeholder="e.g. Telephonic"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
    case "gender":
      return (
        <SelectControl
          mode="multiple"
          status={isHasErrorValue}
          options={["Male", "Female", "Other"]}
          placeholder="e.g. Male"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
    case "disability":
      return (
        <SelectControl
          mode=""
          status={isHasErrorValue}
          options={["Yes", "No", "Prefer not to disclose"]}
          placeholder="e.g. No"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
    case "state":
      return (
        <SelectControl
          mode="multiple"
          status={isHasErrorValue}
          options={states || []}
          placeholder="e.g. Punjab"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
    case "city":
      return (
        <SelectControl
          mode="multiple"
          status={isHasErrorValue}
          options={cities || []}
          placeholder="e.g. Amritsar"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
    case "workWithUs":
      return (
        <SelectControl
          mode=""
          status={isHasErrorValue}
          options={["Yes", "No"]}
          placeholder="e.g. No"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
    case "callStatus":
      return (
        <SelectControl
          mode="multiple"
          status={isHasErrorValue}
          options={callStatus || []}
          placeholder="e.g. No"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
    case "interviewStatus":
      return (
        <SelectControl
          mode="multiple"
          status={isHasErrorValue}
          options={interviewStatus || []}
          placeholder="e.g. Pending"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
    case "openToRelocation":
      return (
        <SelectControl
          mode=""
          status={isHasErrorValue}
          options={["Yes", "No"]}
          placeholder="e.g. No"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
    case "noticePeriod":
      return (
        <SelectControl
          mode="multiple"
          status={isHasErrorValue}
          options={noticePeriods || []}
          placeholder="e.g. 30 Days"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
    case "department":
      return (
        <SelectControl
          mode="multiple"
          status={isHasErrorValue}
          options={departments || []}
          placeholder="e.g. CSE"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
    case "industryWorked":
      return (
        <SelectControl
          mode="multiple"
          status={isHasErrorValue}
          options={industries || []}
          placeholder="e.g. BPO"
          value={value}
          onChange={(value) => onChangeHandler(group?._id, con?._id, value)}
        />
      );
  }

  return (
    <div>
      <Input status={isHasErrorValue} type="text" placeholder="Enter value" />
    </div>
  );
};

export default ParameterValue;
